import { render, staticRenderFns } from "./DocumentStatusBadge.vue?vue&type=template&id=d931eec8&scoped=true&"
import script from "./DocumentStatusBadge.vue?vue&type=script&lang=js&"
export * from "./DocumentStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./DocumentStatusBadge.vue?vue&type=style&index=0&id=d931eec8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d931eec8",
  null
  
)

export default component.exports